import style from '../yeah.module.scss'
import { InView } from "react-intersection-observer"
import animations from '@styles/animations.module.scss'
import Image from 'next/image'
import { isLastIndex } from '../yeah.state'

interface IPreviewSectionProps {
    title: string;
    subtitle: string;
    imageSrc: string;
    imageAlt: string;
    textArray: Array<string>;
}

const PreviewSectionYeah = ({ title, subtitle, imageSrc, imageAlt, textArray }: IPreviewSectionProps) => {
    return (
        <section className={`${style.section} ${style.section_preview} ${style.section_px80}`}>
            <div className={`${style.container}`}>
                <InView triggerOnce={true}>
                    {({ inView, ref, entry }: any) => {
                        if (inView) {
                            entry?.target.classList.add(animations.active);
                        }
                        return (
                            <h1 ref={ref} className={`${style.title} ${style.title_large} ${style.text_align_c} ${style.mb20} ${animations.scroll__animation}`}>
                                {
                                    title
                                }
                            </h1>
                        )
                    }}
                </InView>
                <InView triggerOnce={true}>
                    {({ inView, ref, entry }: any) => {
                        if (inView) {
                            entry?.target.classList.add(animations.active);
                        }
                        return (
                            <div ref={ref} className={`${style.text} ${style.text_middle} ${style.text_align_c} ${animations.scroll__animation}`}>
                                {
                                    subtitle
                                }
                            </div>
                        )
                    }}
                </InView>
                <InView triggerOnce={true}>
                    {({ inView, ref, entry }: any) => {
                        if (inView) {
                            entry?.target.classList.add(animations.active);
                        }
                        return (
                            <div ref={ref} className={`${style.image} ${style.image_preview} ${style.mx60} ${animations.scroll__animation}`}>
                                <Image sizes="800 400 200" src={imageSrc} alt={imageAlt} layout={'fill'} />
                            </div>
                        )
                    }}
                </InView>
                {
                    textArray.map((text: string, index: number) => {
                        return (
                            <InView triggerOnce={true} key={index}>
                                {({ inView, ref, entry }: any) => {
                                    if (inView) {
                                        entry?.target.classList.add(animations.active);
                                    }
                                    return (
                                        <div ref={ref} className={`${style.text} ${style.text_large} ${isLastIndex(index, textArray.length) ? null : style.mb32} ${animations.scroll__animation}`}>
                                            {text}
                                        </div>
                                    )
                                }}
                            </InView>
                        )
                    })
                }
            </div>
        </section>
    )
}

export default PreviewSectionYeah;
